import AssetClassEdit from './AssetClassEdit';
import WebUniversal, { WUExtendPropsType } from '../../system/WebUniversalNewEx'
import { columnsheadId } from '../../universal/columnshead';

//组件 
const WebComponents = (props: any) => {

    /** api服务id */
    const apiId = 'assetClass';

    //表头
    const columnsHead = [
        {
            title: '类别名',
            dataIndex: 'className'
        },
        {
            title: '排序',
            dataIndex: 'sortBy'
        }
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '资产类别',
        apiId,
        columns,
        showStates: true,
        pagination: true,
        EditComponent: AssetClassEdit
    };

    return (
        <WebUniversal props={extendProps} />
    )
}

export default WebComponents;
